interface BoxProps {
  heightClass: string;
  children?: React.ReactNode;
}

const Box: React.FC<BoxProps> = ({ heightClass, children }) => {
  return (
    <div
      className={`relative flex w-full flex-row items-center justify-center ${heightClass}`}
    >
      {children}
    </div>
  );
};

export default Box;
